import { fillAnswerFlows, fillTimekeeping } from "../surveyUtil";
import { BOILERPLATE_ANSWER_FLOWS } from "./presets";
import { COLORSONIC_ANSWER_FLOWS } from "./presets/colorsonic";
import { ESSIE_ANSWER_FLOWS } from "./presets/essie";
import { HAIRCARE_ANSWER_FLOWS } from "./presets/haircare";
import { HAIRCOLOR_ANSWER_FLOWS } from "./presets/haircolor";
import { LOREAL_ANSWER_FLOWS } from "./presets/loreal";
import { MAYBELLINE_ANSWER_FLOWS } from "./presets/maybelline";
import { NYX_ANSWER_FLOWS } from "./presets/nyx";
import { SKINCARE_ANSWER_FLOWS } from "./presets/skincare";

export async function fillEssieMaybelline() {
  fillTimekeeping();

  await fillAnswerFlows(BOILERPLATE_ANSWER_FLOWS);

  await fillAnswerFlows(ESSIE_ANSWER_FLOWS);
  await fillAnswerFlows(MAYBELLINE_ANSWER_FLOWS);
}

export async function fillLorealNyx() {
  fillTimekeeping();

  await fillAnswerFlows(BOILERPLATE_ANSWER_FLOWS);

  await fillAnswerFlows(LOREAL_ANSWER_FLOWS);
  await fillAnswerFlows(NYX_ANSWER_FLOWS);
}

export async function fillColorsonicHairCareAndColor() {
  fillTimekeeping();

  await fillAnswerFlows(BOILERPLATE_ANSWER_FLOWS);

  await fillAnswerFlows(COLORSONIC_ANSWER_FLOWS);
  await fillAnswerFlows(HAIRCOLOR_ANSWER_FLOWS);
  await fillAnswerFlows(SKINCARE_ANSWER_FLOWS);
  await fillAnswerFlows(HAIRCARE_ANSWER_FLOWS);
}

export async function fillHairCareAndColor() {
  fillTimekeeping();

  await fillAnswerFlows(BOILERPLATE_ANSWER_FLOWS);

  await fillAnswerFlows(HAIRCOLOR_ANSWER_FLOWS);
  await fillAnswerFlows(SKINCARE_ANSWER_FLOWS);
  await fillAnswerFlows(HAIRCARE_ANSWER_FLOWS);
}

export async function blitzCosmetics() {
  fillTimekeeping();

  await fillAnswerFlows(BOILERPLATE_ANSWER_FLOWS);

  await fillAnswerFlows(LOREAL_ANSWER_FLOWS);
  await fillAnswerFlows(NYX_ANSWER_FLOWS);

  await fillAnswerFlows(ESSIE_ANSWER_FLOWS);
  await fillAnswerFlows(MAYBELLINE_ANSWER_FLOWS);
}

export async function blitzNonCosmetics() {
  await fillAnswerFlows(BOILERPLATE_ANSWER_FLOWS);

  await fillAnswerFlows(COLORSONIC_ANSWER_FLOWS);
  await fillAnswerFlows(HAIRCOLOR_ANSWER_FLOWS);
  await fillAnswerFlows(SKINCARE_ANSWER_FLOWS);
  await fillAnswerFlows(HAIRCARE_ANSWER_FLOWS);
}
